<template>
  <div class="home">
    <listselect v-if="listSelectShow==true" class="listselect" :map="map" :listselects="listselects"></listselect>
    <leftpage class="homel" v-if="btnactivelen==0 && openLeft" @xcClickNames="xcClickNames" @xcDialogVisibles="xcDialogVisibles" @yhClickNames="yhClickNames" @yhDialogVisibles="yhDialogVisibles"></leftpage>
    <rightpage class="homer" v-if="btnactivelen==0 && openRight"></rightpage>
    <Ldwgc class="homel" v-if="btnactivelen==3" :gisclick="gisrightdata"></Ldwgc>
    <Rdwgc class="homer" v-if="btnactivelen==3" :gisclick="gisrightdata"></Rdwgc>

    <xcDialog v-if="xcDialogVisible==true" @cancel="xcCancel" :xcClickName="xcClickName"></xcDialog>
    <yhDialog v-if="yhDialogVisible==true" @cancel="yhCancel" :yhClickName="yhClickName"></yhDialog>

    <span class="shipinButton" v-if="btnactivelen==3" @click="shipinClick" title='视频运行管理'></span>
    <shipinDialog v-if="shipinDialogVisible==true" @cancel="spCancel" :gisclick="gisrightdata"></shipinDialog>
    <!-- 左右收缩 -->
    <div v-if="btnactivelen==0" style="position: absolute;z-index: 100;top: 45%;" :class="[openLeft ? 'imgLeft' : 'imgLeft1']" @click="clickLeft">
      <img v-show="!openLeft" style="height: 77px; width: 26px; " src="../../common/images/right.png"/>
      <img v-show="openLeft" style="height: 77px; width: 26px; " src="../../common/images/left.png"/>
    </div>
    <div v-if="btnactivelen==0" style="position: absolute;z-index: 100;top: 45%;" :class="[openRight ? 'imgRight' : 'imgRight1']" @click="clickRight">
      <img v-show="!openRight" style="height: 77px; width: 26px; " src="../../common/images/right.png"/>
      <img v-show="openRight" style="height: 77px; width: 26px; " src="../../common/images/left.png"/>
    </div>
  </div>
</template>

<script>
  import leftpage from "./leftPage.vue";
  import rightpage from "./rightPage.vue";
  import Ldwgc from "./Ldwgc.vue";
  import Rdwgc from "./rdwgc.vue";
  import listselect from '@/components/visualization/LlistSelect.vue';
  import xcDialog from "./xcDialog.vue";
  import yhDialog from "./yhDialog.vue";
  import shipinDialog from '@/components/visualization/shipinDialog.vue';

  export default {
    props: ["gisClick", "map", "querydatas", 'dbRouteShow','listselects'],
    data() {
      return {
        btnactivelen: 0,
        gisrightdata: null,
        listSelectShow: true,

        xcDialogVisible: false,
        yhDialogVisible: false,
        shipinDialogVisible: false,
        xcClickName: [],
        yhClickName: [],
        openLeft: true,
        openRight: true,
        listselects:[]
      };
    },
    components: {
      leftpage,
      rightpage,
      Ldwgc,
      Rdwgc,
      listselect,
      xcDialog,
      yhDialog,
      shipinDialog
    },
    mounted() {
      this.$emit("activeRoute", 3);
      if (this.dbRouteShow == true) {
        this.btnactivelen = 3;
        this.listSelectShow = false;
      } else{
        this.btnactivelen = 0;
        this.listSelectShow = true;
      }
    },
    computed: {
      fanhuiStatus() {
        return this.$store.state.fanhuiShow; //需要监听的数据
      },

    },
    watch: {
      gisClick: {
        handler(newVal, oldVal) {
          // if(!newVal){
          //   newVal = this.$store.state.fanhuiShow
          // }
          // console.log(newVal,this.$store.state.fanhuiShow,'获取单坝---运行管理NewVal')

          let _this = this;
          if (newVal) {
            this.listSelectShow = false;
            this.btnactivelen = 3;
            this.$emit("rootBarShow", true);
            setTimeout(function() {
              _this.gisrightdata = newVal;
            }, 200);
          }
        },
        immediate: true,
        deep: true,
      },
      querydatas(data, data1) {
        if(!data){
          data = this.$store.state.querydatas
        }
        // console.log(data,this.$store.state.querydatas,'获取单坝---运行管理')
        let _this = this;
        if (!data) {
          this.btnactivelen = 0;
          this.$emit("rootBarShow", false);
          this.$store.commit('fanhuiFun', true); //token
        } else{
          this.btnactivelen = 3;
          this.listSelectShow = false;
          this.$emit("rootBarShow", true);
          this.$store.commit('fanhuiFun', false); //token
          setTimeout(function() {
            _this.gisrightdata = data;
          }, 200);
        }
      },
      fanhuiStatus(newVal, oldVal) {
        // console.log('---->返回--',newVal)
        if (newVal == true) {
          this.listSelectShow = true;
          this.btnactivelen = 0;
          this.gisrightdata = null;
          this.$emit("rootBarShow", false);
        }
      },
    },
    methods: {
      btnClick(item, i) {
        this.btnactivelen = i;
      },
      shipinClick() {
        this.shipinDialogVisible = true;
      },
      xcClickNames(data) {
        // console.log(data)
        this.xcClickName = data;
      },
      xcDialogVisibles(data) {
        // console.log(data)
        this.xcDialogVisible = data;
      },
      yhClickNames(data) {
        // console.log(data)
        this.yhClickName = data;
      },
      yhDialogVisibles(data) {
        // console.log(data)
        this.yhDialogVisible = data;
      },
      xcCancel() {
        this.xcDialogVisible = false;
      },
      yhCancel() {
        this.yhDialogVisible = false;
      },
      spCancel() {
        this.shipinDialogVisible = false;
      },
      clickLeft() {
      this.openLeft = !this.openLeft;
      this.$emit("changeStyle", {leftStyle: this.openLeft,rightStyle: this.openRight });
      },
      clickRight() {
        this.openRight = !this.openRight;
        this.$emit("changeStyle",  {leftStyle: this.openLeft,rightStyle: this.openRight });
      },
    },
  };
</script>

<style scoped="scoped">
  .home {
    position: absolute;
    left: 0;
    height: 0;
    width: 100%;
    height: 100%;
    /* z-index: 1; */
  }

  .homel,
  .homer {
    width: 380px;
    position: absolute;
    z-index: 100;
    top: 70px;
    overflow: auto;
    background: transparent;
    bottom: 10px;
  }

  .homel {
    left: 0px;

  }

  .homer {
    right: 0px;
    /* box-shadow: -12px 13px 13px #1e3456 */
  }

  .listselect {
    z-index: 2;
  }

  .shipinButton {
    position: absolute;
    right: 400px;
    top: 190px;
    width: 50px;
    height: 50px;
    z-index: 10;
    color: #fff;
    font-size: 16px;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
    /* border: 1px solid #00b3fe; */
    /* background: rgba(53, 65, 84, 0.7); */
    background: url(../../common/images/video.png) no-repeat center;
    background-size: 100% 100%;
  }

  /* .shipinButton:hover {
    color: #ffe557;
    border: 1px solid #ffe557;
  } */
</style>
